import { contextValues } from '@streem/logger';
import { logger } from '../../util/logger';
import { BookmarkController } from '../controllers/bookmark_controller';
import { DetectionController } from '../controllers/detection_controller';
import { GeolocationController } from '../controllers/geolocation_controller';
import { InvitationController } from '../controllers/invitation_controller';
import { NoteController } from '../controllers/notes_controller';
import { PersonalizationController } from '../controllers/personalization_controller';
import { RecordingController } from '../controllers/recording_controller';
import { RoomController } from '../controllers/room_controller';
import { StreemshotController } from '../controllers/streemshot_controller';
import { TranscriptionController } from '../controllers/transcription_controller';
import { UserController } from '../controllers/user_controller';
import { RoomWall } from '../wall/room_wall';
import { RoomWallSyncBuilder } from '../wall/wall_sync_builder';
export class DetailSession {
    static async initialize(config) {
        return new DetailSession(config, await new RoomWallSyncBuilder(config.roomId, config.deviceId, config.userId, config.readOnly).build());
    }
    constructor(config, wallSyncClient) {
        this.config = config;
        this.roomId = config.roomId;
        this.roomWall = new RoomWall({
            alive: false,
            roomId: config.roomId,
            localUserId: config.userId,
            localDeviceId: config.deviceId,
            wallSyncClient: wallSyncClient,
        });
        this.bookmarks = new BookmarkController(this.controllerConfig);
        this.personalizations = new PersonalizationController(this.controllerConfig);
        this.detection = new DetectionController(this.controllerConfig);
        this.geolocation = new GeolocationController(this.controllerConfig);
        this.invitations = new InvitationController(this.controllerConfig);
        this.note = new NoteController(this.controllerConfig);
        this.recording = new RecordingController(this.controllerConfig);
        this.room = new RoomController(this.controllerConfig);
        this.streemshots = new StreemshotController(this.controllerConfig);
        this.users = new UserController(this.controllerConfig);
        this.transcriptionController = new TranscriptionController(this.controllerConfig);
        // Logs
        logger.setContextValue(contextValues.ROOM_ID, config.roomId.toString());
    }
    get controllerConfig() {
        return {
            roomWall: this.roomWall,
            context: {
                localUserId: this.config.userId,
                localDeviceId: this.config.deviceId,
                roomId: this.config.roomId,
                transcriptionsEnabledYn: this.config.transcriptionsEnabledYn,
            },
        };
    }
    async connect() {
        logger.info(`The Detail session was created ${this.roomId}`);
        await this.roomWall.connect();
    }
    async endSession() {
        try {
            await this.roomWall.disconnect();
        }
        catch (e) {
            logger.error('Failed to disconnect Wall', e);
        }
        this.transcriptionController.disconnect();
        logger.info(`The Detail session has ended ${this.roomId}`);
        logger.removeContextValue(contextValues.ROOM_ID);
    }
}
//# sourceMappingURL=detail_session.js.map